/*
 * <location-map> — single-store Leaflet map on the location detail page.
 *
 * Same stack as the locations index locator (self-hosted assets/leaflet.js, CARTO
 * Voyager tiles, brand divIcon pin), reduced to one pin centered on the store.
 * Scroll-wheel zoom stays off because this page scrolls — the wheel should move the
 * page, not the map; the zoom control and pinch gestures still work.
 *
 * Progressive enhancement: without JS the <noscript> Google embed takes over.
 */

const LOCATION_PIN_SVG = `
  <svg viewBox="0 0 24 32" focusable="false" aria-hidden="true">
    <path d="M12 0C5.4 0 0 5.4 0 12c0 9 12 20 12 20s12-11 12-20C24 5.4 18.6 0 12 0z"/>
    <circle cx="12" cy="12" r="4.5"/>
  </svg>
`;

class LocationMap extends HTMLElement {
  connectedCallback() {
    const canvas = this.querySelector('[data-location-map-canvas]');
    const lat = parseFloat(this.dataset.lat);
    const lng = parseFloat(this.dataset.lng);

    if (!canvas || typeof L === 'undefined' || Number.isNaN(lat) || Number.isNaN(lng)) return;

    this.map = L.map(canvas, { scrollWheelZoom: false });

    L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png?key=cb1_2usf_1_6fd16dc3d6347ef77e1e9824', {
      subdomains: 'abcd',
      maxZoom: 20,
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions" target="_blank" rel="noopener">CARTO</a>',
    }).addTo(this.map);

    const icon = L.divIcon({
      className: 'locations-pin',
      html: LOCATION_PIN_SVG,
      iconSize: [30, 40],
      iconAnchor: [15, 38],
      ariaLabel: 'Location marker',
    });

    L.marker([lat, lng], { icon }).addTo(this.map);
    this.map.setView([lat, lng], 15);
  }

  disconnectedCallback() {
    this.map?.remove();
  }
}

customElements.define('location-map', LocationMap);
